<script setup lang="ts">
import { computed } from 'vue';

type Direction = 'down' | 'left' | 'up' | 'right';

const DIRECTION_ROTATION_CLASS_MAP: Record<Direction, string> = {
  down: 'rotate-0',
  left: 'rotate-90',
  up: 'rotate-180',
  right: '-rotate-90'
};

const { direction = 'down' } = defineProps<{
  direction?: Direction;
}>();

const rotationClass = computed(() => DIRECTION_ROTATION_CLASS_MAP[direction]);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    class="transition-transform"
    :class="rotationClass"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.168l3.71-3.938a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06Z"
      clip-rule="evenodd"
    />
  </svg>
</template>
